import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Strong,
} from 'components/core';
import { Text } from 'components/core/Typography';

export const LeaveOrganizationModal = (props: {
  isOpen: boolean;
  organizationName: string;
  onClose: () => void;
  onRemove: () => void;
}) => {
  const { isOpen, organizationName, onClose, onRemove } = props;
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalHeader>Leave organization?</ModalHeader>
      <ModalBody>
        <Text size="md" variant="neutral">
          You&apos;re about to leave the organization &quot;
          <Strong>{organizationName}</Strong>&quot;
          <br />
          <br />
          Once you leave, you&apos;ll no longer have access to this
          organization.
          <br />
          <br />
          Are you sure you want to leave?
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose} variant="outline">
          Cancel
        </Button>
        <Button type={'danger'} onClick={onRemove}>
          Leave organization
        </Button>
      </ModalFooter>
    </Modal>
  );
};
